<template>
    <main class="register_form">
        <form data-abide novalidate data-validate-on-blur="true" id="registerForm" v-show="!isUserLogged && formEnable">
            <!-- BEGIN KYC -->
            <section class="grid-x grid-margin-x align-justify block-section" v-if="step === 0">
                <div class="cell large-12">
                    <h2>
                        Register for a free myLottery360&deg; Account!
                    </h2>
                </div>
                <div class="cell large-12">
                    <label for="email-address">
                        <input 
                            type="email" 
                            id="email-address" 
                            v-model="userName"
                            @blur="validateEmail"
                            placeholder="Email Address *"
                            required aria-label="Email Address *"
                        >
                        <span class="form-error"> Please provide a valid Email Address</span>
                        <span class="error" v-if="emailError === true">You're email contains a restricted character</span>
                    </label>
                </div>
                <div class="cell large-12">
                    <label for="confirm-email-address">
                        <input 
                            id="confirm-email-address" 
                            type="email" 
                            v-model="userNameMatch"
                            @input="checkForVerifyLaunch"
                            placeholder="Confirm Email Address *" 
                            data-equalto="email-address" 
                            required aria-label="Confirm Email Address *"
                        >
                        <span class="form-error">Emails do not match</span>
                    </label>
                </div>
                <div class="personaInstructions">
                    <p>
                        You are required to verify your identity before creating your myLottery360&deg; account. This helps us prevent unauthorized access to your account and protect you personal information
                    </p>
                    <h2>What do I need to verify my ID?</h2>
                    <p>You will need these items to verify your ID:</p>
                    <ul>
                    <li>A valid drivers license, state-issued ID or passport</li>
                    <li>Access to a smartphone, tablet or computer with a camera</li>
                    </ul>
                </div>
                <button class="button verify-button"
                        :class="{ disabled: !userNameMatchCheck }"
                        :disabled="!userNameMatchCheck"
                        type="button"
                        @click="nextStep"
                        v-if="step === 0"
                >
                    Verify my id
                </button>
            </section>

            <!-- STEP 1 -->
            <section class="grid-container" v-if="step === 1">
            <!-- <p>Persona Workflow step</p> -->
                <!-- <button class="button" @click="step = 2">NEXT STEP</button>  -->
                 <p>Please wait while we get things started...</p>
            </section>

            <!-- STEP 2 -->
            <section class="grid-container regContactFields" v-if="step === 2">
                <p>
                    Congratulations! We have verified your ID. We just need a few more
                    details to create your account. Fields marked with * are required
                </p>

                <div>
                    <section class="grid-x grid-margin-x align-justify block-section">
                        <div class="cell large-12">
                            <label for="email-address">
                                <input type="email" v-model="userName" @input="validateEmail()"
                                    required aria-label="Email Address *" disabled>
                                <!-- <span class="form-error"> Please provide a valid Email Address</span> -->
                                <!-- <span class="error" v-if="emailError === true">You're email contains a restricted character</span> -->
                            </label>
                        </div>
                        <!-- <div class="cell large-12">
                            <label for="confirm-email-address">
                                <input id="confirm-email-address" type="email" placeholder="Confirm Email Address *" 
                                    data-equalto="email-address" required aria-label="Confirm Email Address *">
                                <span class="form-error">Emails do not match</span>
                            </label>
                        </div> -->
                        <div class="cell large-6">
                            <label for="firstName">
                                <input 
                                id="firstName" type="text" v-model="firstName" @blur="validateName('first')" placeholder="First Name *" required aria-label="First Name *" disabled>
                                <!-- <span class="form-error">Please enter your First Name</span> -->
                                <!-- <span class="error" v-if="errorFirstName">A users first name may only include Letters, Numbers, space, period, comma or hyphen.</span> -->
                            </label>
                        </div>
                        <div class="cell large-6">
                            <label for="lastName">
                                <input id="lastName" type="text" v-model="lastName" @blur="validateName('last')" placeholder="Last Name *" required aria-label="Last Name *" disabled>
                                <!-- <span class="form-error">Please enter your Last Name</span> -->
                                <!-- <span class="error" v-if="errorLastName">A users last name may only include Letters, Numbers, space, period, comma or hyphen.</span> -->
                            </label>
                        </div>
                        <div class="cell large-6">
                            <label for="gender">
                                <select id="gender" v-model="gender" required aria-label="Select Your Gender *">
                                    <option value="" disabled selected aria-disabled="true">Select Your Gender *</option>
                                    <option value="0">Female</option>
                                    <option value="1">Male</option>
                                    <option value="2">Other</option>
                                    <option value="3">Prefer not to say</option>
                                </select>
                                <span class="form-error">Please enter your Gender</span>
                            </label>
                        </div>
                        <div class="cell large-6">
                            <label for="date_birth">
                                <input id="date_birth" type="date" placeholder="Date Of Birth *" date-date-format="mm/dd/yyyy" name="dateOfBirth"
                                    :format="customFormatter" v-model="date_birth" @blur="dateSelected()"
                                    :class="{ 'is_valid': birth_error }" required aria-label="Date of Birth *" aria-describedby="dobHint" disabled>
                                <!-- <small class="visually-hidden" id="dobHint">Format: mm/dd/yyyy</small> -->
                                <!-- <span class="form-error-birth" v-if="birth_error">You must be over 18</span> -->
                            </label>

                            <div class="cell large-6">
                                <label for="ageCheckbox" class="inline-check">
                                    <input required id="ageCheckbox" name="ageCheckbox" type="checkbox" v-model="ageCheck" aria-label="I certify that I am 18 years of age or older">
                                    <span>I certify that I am 18 years of age or older *</span>
                                    <span class="form-error" v-if="ageCheckError">Please confirm that you are 18 years or
                                        older</span>
                                </label>
                                <small><em>We request your date of birth to confirm that members are of legal age to participate
                                        in Washington’s Lottery.</em></small>
                            </div>
                        </div>
                    </section>
                    <!-- STEP 2 -->
                    <section class="grid-x grid-margin-x align-justify block-section" id="mailingAddressBlock">
                        <div class="cell large-12">
                            <h2>Mailing Address</h2>
                            <p class="legend">
                                <em>We’re looking forward to sending your rewards to you! Please provide a valid street
                                    address for your account registration. We cannot accept PO Boxes or addresses outside the US
                                    at this time. Thank you for your understanding.</em>
                            </p>
                        </div>
                        <div class="cell large-12">
                            <label for="addressLineOne">
                                <input id="addressLineOne" type="text" v-model="mailingAddress" placeholder="Address Line 1 *" name="mailingAddress" required aria-label="Address Line 1*">
                                <span class="form-error">
                                    Please enter your Address
                                </span>
                            </label>
                        </div>
                        <div class="cell large-12">
                            <label for="addressLineTwo">
                                <input id="addressLineTwo" type="text" v-model="addressContinued" name="addressContinued" placeholder="Address Line 2" aria-label="Address Line 2">
                            </label>
                        </div>
                        <div class="cell large-6">
                            <label for="city">
                                <input id="city" type="text" placeholder="City *" v-model="city" name="city" required aria-label="City *">
                                <span class="form-error">Please enter your City</span>
                            </label>
                        </div>
                        <div class="cell large-3">
                            <label for="stateSelect">
                                <select id="stateSelect" v-model="state" name="state" required aria-label="State *">
                                    <option value="AL"> AL</option>
                                    <option value="AK"> AK</option>
                                    <option value="AZ"> AZ</option>
                                    <option value="AR"> AR</option>
                                    <option value="CA"> CA</option>
                                    <option value="CO"> CO</option>
                                    <option value="CT"> CT</option>
                                    <option value="DC"> DC</option>
                                    <option value="DE"> DE</option>
                                    <option value="FL"> FL</option>
                                    <option value="GA"> GA</option>
                                    <option value="HI"> HI</option>
                                    <option value="ID"> ID</option>
                                    <option value="IL"> IL</option>
                                    <option value="IN"> IN</option>
                                    <option value="IA"> IA</option>
                                    <option value="KS"> KS</option>
                                    <option value="KY"> KY</option>
                                    <option value="LA"> LA</option>
                                    <option value="ME"> ME</option>
                                    <option value="MD"> MD</option>
                                    <option value="MA"> MA</option>
                                    <option value="MI"> MI</option>
                                    <option value="MN"> MN</option>
                                    <option value="MS"> MS</option>
                                    <option value="MO"> MO</option>
                                    <option value="MT"> MT</option>
                                    <option value="NE"> NE</option>
                                    <option value="NV"> NV</option>
                                    <option value="NH"> NH</option>
                                    <option value="NJ"> NJ</option>
                                    <option value="NM"> NM</option>
                                    <option value="NY"> NY</option>
                                    <option value="NC"> NC</option>
                                    <option value="ND"> ND</option>
                                    <option value="OH"> OH</option>
                                    <option value="OK"> OK</option>
                                    <option value="OR"> OR</option>
                                    <option value="PA"> PA</option>
                                    <option value="PR"> PR</option>
                                    <option value="RI"> RI</option>
                                    <option value="SC"> SC</option>
                                    <option value="SD"> SD</option>
                                    <option value="TN"> TN</option>
                                    <option value="TX"> TX</option>
                                    <option value="UT"> UT</option>
                                    <option value="VA"> VA</option>
                                    <option value="VI"> VI</option>
                                    <option value="VT"> VT</option>
                                    <option value="WA" selected> WA</option>
                                    <option value="WV"> WV</option>
                                    <option value="WI"> WI</option>
                                    <option value="WY"> WY</option>
                                </select>
                                <span class="form-error">Please enter your State</span>
                            </label>
                        </div>
                        <div class="cell  large-3">
                            <label for="zipcode">
                                <input id="zipcode" type="text" minlength="5" maxlength="5" placeholder="Zip Code *" v-model="zipcode" name="zipcode" required pattern="\d{5}" title="Enter a 5-digit ZIP code" aria-label="Zipcode">
                                <span class="form-error">Please provide a valid Zip Code</span>
                            </label>
                        </div>
                        <div class="cell medium-6">
                            <label for="phoneNumber">
                                <input type="tel" id="phoneNumber" placeholder="Phone Number *" required
                                    pattern="^\d{3}-\d{3}-\d{4}$" aria-describedby="phoneFormatHint" v-model="phoneNumber" @input="formatPhone(phoneNumber)" aria-label="Phone Number *">
                                <small class="visually-hidden" id="phoneFormatHint">Format: 123-456-7890</small>
                                <span class="form-error">Please provide a valid Phone Number</span>
                            </label>
                        </div>
                    </section>
                    <!-- STEP 3 -->
                    <section class="grid-x grid-margin-x align-justify block-section">
                        <div class="cell large-12">
                            <h2>Login Information </h2>
                        </div>
                        <div class="cell large-12">
                            <label for="password">
                                <input type="password" id="password" placeholder="Password *" v-model="password"
                                    :class="{ 'is-invalid-input': passwordError }" @blur="validate" @keyup="keyUp('validate')"
                                    @keydown="keyDown" :pattern="rules"
                                    required aria-label="Password *">


                                <password v-model="password" :strength-meter-only="true" />

                                <ul v-if="passwordError" class="error non-abide">
                                    <li v-if="!passwordLength">Passwords must be a minimum of 10 characters.</li>
                                    <li v-if="!passwordNumber">Passwords require at least one number.</li>
                                    <li v-if="passwordCharacter">Passwords may not include spaces.</li>
                                    <li v-if="!passwordSpecial">Passwords require at least one symbol.</li>
                                    <li v-if="!passwordUppercase">Passwords require at least one uppercase character.</li>
                                    <li v-if="!passwordLowercase">Passwords require at least one lowercase character.</li>
                                </ul>
                            </label>
                            <p class="legend"><em>Please keep in mind that your password must be at least 10 characters long and
                                    contain the following: an
                                    uppercase letter, a lowercase letter, a number and a symbol.</em></p>
                        </div>
                        <div class="cell medium-12">
                            <label for="confirm-password">
                                <input id="confirm-password" type="password" placeholder="Confirm Password *" data-equalto="password" required v-model="confirmPassword" @blur="validate" aria-label="Confirm Password *">
                                <span class="form-error">Passwords do not match</span>
                            </label>
                        </div>
                    </section>
                    <!-- STEP 4 -->
                    <section class="grid-x grid-margin-x align-justify block-section">
                        <div class="cell large-12">
                            <h2>Select Games and Notifications</h2>
                            <NotificationSettings @receive-offers="handleOffers" @notification-list="handleCheckbox">
                            </NotificationSettings>
                        </div>
                    </section>
                    <!-- STEP 5 -->
                    <section class="grid-x grid-margin-x align-justify block-section">
                        <div class="cell large-12">
                            <label for="agreeTermsCheck" class="inline-check">
                                <input type="checkbox" name="agreeTermsCheck" id="agreeTermsCheck" v-model="agreeTermsCheck"
                                    required aria-label="Agree Terms">
                                <span class="agreeTermsCheck">I agree with Washington’s Lottery <a href="#"
                                        @click="openTermsModal">Terms of Service</a>*</span>
                                <span class="form-error" v-if="agreeTermsCheckError">Please confirm that you are agree with
                                    Washington’s Lottery Terms of Service</span>
                            </label>
                        </div>
                    </section>

                    <section class="grid-x grid-margin-x block-section">
                        <div class="cell large-12 action-section">
                            <!-- <h4>Submit Below</h4> -->
                            <!-- <button type="submit" class="button submit-button" @click="submitCheck">Create Account</button> -->
                            <button id="trial" class="button submit-button" @click="submitCheck">Create Account</button>
                        </div>
                    </section>

                    <!-- MODAL TERMS -->
                    <section class="large reveal callout terms-modal" id="termsModal" data-reveal data-close-on-click="false" role="dialog" aria-modal="true" aria-labelledby="termsModalTitle">
                        <div class="grid-x">
                            <p class="h5" id="termsModalTitle">Terms and Conditions</p>
                            <div class="cell small-12">
                                <div class="terms" v-html="termsContent"></div>
                            </div>
                        </div>
                        <button class="close-button" data-close aria-label="Close modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </section>

                    <!-- MODAL ERROR -->
                    <section class="medium reveal callout alert error-modal" id="errorRegisterModal" data-reveal data-close-on-click="false" role="alertdialog"  aria-modal="true" aria-labelledby="errorModalTitle">
                        <div class="grid-x">
                            <p class="h5" id="errorModalTitle">Error</p>
                            <div class="cell small-12">
                                <div class="">{{ registerErrorMsg }}</div>
                            </div>
                        </div>
                        <button class="close-button" data-close aria-label="Close modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </section>
                </div>
            </section>

            <div class="failedKYC" v-if="step === 3">
                <div>
                    <h1>Unable to verify your ID</h1>
                    <p>I'm sorry, we are unable to verify your ID.</p>
                    <p>Possible reasons for an unsuccessful verification include:</p>
                    <ul>
                    <li>The form of identification already exists in our records</li>
                    <li>The form of identification is expired</li>
                    <li>
                        The details on the form of identification were unclear or blurry
                    </li>
                    <li>
                        The ID type detected does not match the ID type you've selected
                    </li>
                    <li>There was a problem with your Selfie verification</li>
                    </ul>
                    <p>
                    If you need assistance, please contact MyLotto Rewards customer
                    support:
                    </p>
                    <p>
                    <a href="/mylotto-rewards/help" aria-label="Help"
                        >Online Help Center</a
                    >
                    </p>
                    <p>Helpline: <a href="tel:+8553197189">(855) 319-7189</a></p>
                    <div>
                    <button
                        type="button"
                        class="button btn-tertiary"
                        @click="kycTryAgain"
                    >
                        Try Again
                    </button>
                    </div>
                </div>
                </div>
        </form>
    </main>
</template>

<script>
import Datepicker from "vue-moment-datepicker";
import $ from 'jquery';
import Password from 'vue-password-strength-meter'
import NotificationSettings from '../Account/NotificationSettings.vue';
import moment from 'moment';

export default {
    components: {
        Datepicker,
        Password,
        NotificationSettings
    },
    data: function () {
        return {
            // dummyData: {"current-government-id":{"type":"government_id","value":{"id":"doc_nX8Umygc55feaee8qhfAxuBbsYjY","type":"Document::GovernmentId"}},"selected-country-code":{"type":"string","value":"US"},"selected-id-class":{"type":"string","value":"dl"},"address-street-1":{"type":"string","value":"7951 SKYLINE DR"},"address-street-2":{"type":"string","value":null},"address-city":{"type":"string","value":"BROADVIEW HTS"},"address-subdivision":{"type":"string","value":"OH"},"address-postal-code":{"type":"string","value":"44147"},"address-country-code":{"type":"string","value":"US"},"birthdate":{"type":"date","value":"1983-05-03"},"expiration-date":{"type":"date","value":"2032-05-03"},"email-address":{"type":"string","value":null},"identification-class":{"type":"string","value":"dl"},"identification-number":{"type":"string","value":"TS835451"},"name-first":{"type":"string","value":"ERIC"},"name-middle":{"type":"string","value":"JAMES"},"name-last":{"type":"string","value":"WRIGHT"},"phone-number":{"type":"string","value":null},"current-selfie":{"type":"selfie","value":{"id":"self_ZTD9aLTKz4da1s1z252AMNHFVQHv","type":"Selfie::ProfileAndCenter"}}}, // DUMMY RETURN from Persona using Eric's REAL DATA! Only use for testing!!!
            isUserLogged: this.isUserAuthed(),
            step: 0,

            firstName: '',
            lastName: '',
            gender: '',
            date_birth: '',
            birth_error: false,
            mailingAddress: '',
            addressContinued: '',
            city: '',
            state: 'WA',
            zipcode: '',
            country: 'USA',
            phoneNumber: '',

            userName: '',
            password: null,
            confirmPassword: null,

            transactionID: null,
            summary: null,
            verified: false,
            isMobile: false,
            appVersion: null,
            verifiedDate: null,
            inquiryID: null,

            subscribeToOffers: false,
            notifications: {
                "cashPopWNEmail": false,
                "cashPopWNPN": false,
                "powerJRollEmail": false,
                "powerJRollPN": false,
                "powerWNEmail": false,
                "powerWNPN": false,
                "power100JAEmail": false,
                "power100JAPN": false,
                "power200JAEmail": false,
                "power200JAPN": false,
                "power300JAEmail": false,
                "power300JAPN": false,
                "power400JAEmail": false,
                "power400JAPN": false,
                "megaJRollEmail": false,
                "megaJRollPN": false,
                "megaWNEmail": false,
                "megaWNPN": false,
                "mega100JAEmail": false,
                "mega100JAPN": false,
                "mega200JAEmail": false,
                "mega200JAPN": false,
                "mega300JAEmail": false,
                "mega300JAPN": false,
                "mega400JAEmail": false,
                "mega400JAPN": false,
                "lottoJRollEmail": false,
                "lottoJRollPN": false,
                "lottoWNEmail": false,
                "lottoWNPN": false,
                "lotto3JAEmail": false,
                "lotto3JAPN": false,
                "lotto4JAEmail": false,
                "lotto4JAPN": false,
                "lotto5JAEmail": false,
                "lotto5JAPN": false,
                "lotto7JAEmail": false,
                "lotto7JAPN": false,
                "hit5JRollEmail": false,
                "hit5JRollPN": false,
                "hit5WNEmail": false,
                "hit5WNPN": false,
                "hit5500JAEmail": false,
                "hit5500JAPN": false,
                "match4WNEmail": false,
                "match4WNPN": false,
                "pick3WNEmail": false,
                "pick3WNPN": false,
                "dailyKenoWNEmail": false,
                "dailyKenoWNPN": false,
                "allNewGamesEmail": false,
                "allNewGamesPN": false,
                "newGames1Email": false,
                "newGames1PN": false,
                "newGames2Email": false,
                "newGames2PN": false,
                "newGames3Email": false,
                "newGames3PN": false,
                "newGames5Email": false,
                "newGames5PN": false,
                "newGames10Email": false,
                "newGames10PN": false,
                "newGames20Email": false,
                "newGames20PN": false,
                "newGames30Email": false,
                "newGames30PN": false,
                "subscribeToOffers": false,
            },

            emailError: false,

            eighteen: false,

            termsTitle: '',
            termsContent: '',

            registerApiToken: '',
            registerErrorMsg: '',
            formEnable: true,
            formSuccess: false,

            rules: "^(?=.*\\d)(?!.*\\s)(?=.*[~!@#$%^&*()_+\\-=\\[\\]{};:'\",./<>?])(?=.*[A-Z])(?=.*[a-z])(?=.{10,}$).*$",
            passwordValid: false,
            passwordError: false,
            test: '',
            confirmSubmit: false,

            errorFirstName: false,
            errorLastName: false,

            passwordLowercase: true,
            passwordUppercase: true,
            passwordNumber: true,
            passwordLength: true,
            passwordCharacter: true,
            passwordSpecial: true,

            ageCheck: false,
            ageCheckError: false,
            agreeTermsCheck: false,
            agreeTermsCheckError: false,
            checkSubmit: 0,

            userNameMatch: "",
            userNameMatchCheck: false,
            minimumAppVersion: "",
            summary: "",
            transactionID: "",
            suggestedAvailable: true,
        }
    },
    mounted: function () {
        $(document).foundation();
        this.getToken();
        // this.getPasswordRules();

        this.isUserLogged && this.redirectToUrl('/my-profile');
    },
    methods: {
        handleOffers(val) {
            this.subscribeToOffers = val;
        },
        handleCheckbox(val) {
            const filteredArray = val.reduce((result, notificationGroup) => {
                notificationGroup.games.forEach(game => {
                    const typeAlert = game.typeAlert;
                    if (typeAlert) {
                        Object.assign(result, typeAlert);
                    }
                });

                return result;
            }, {});
            this.notifications = filteredArray;
        },
        openTermsModal() {
            $('#termsModal').foundation('open');
        },
        closeTermsModal() {
            $('#errorAddressModal').foundation('close');
        },
        async getPasswordRules() {
            var apiToken = this.token,
                url = process.env.VUE_APP_APIURL + '/1.0/PAM/GetPasswordRules';

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + apiToken,
                    },
                }
                );
                const json = await response.json();
                this.rules = json.data;
                this.test = new RegExp(this.rules.regularExpression);
            } catch (error) {
                return (this.errorMessage = error);
            }
        },
        keyDown() {
            clearTimeout(this.keyTimer);
        },
        keyUp(method) {
            clearTimeout(this.keyTimer);
            if (method === 'match') {
                if (this.confirmPassword != '') {
                    this.keyTimer = setTimeout(this.match, 400);
                }
            }

            if (method === 'validate') {
                this.keyTimer = setTimeout(this.validate, 400);
            }
        },
        validateEmail() {
            let email = this.userName;

            if (email.includes("+")) {
                this.emailError = true;
            } else {
                this.emailError = false;
            }
            
            const characters = /^[\w\.]+@([\w]+\.)/;
            // Also the email cannot start with a "."
            if (this.userName[0] == ".") {
                this.userError = true;
                $(".form-error:has(.email-error)").css("display","block");
                $("#email-address").addClass("invalid-input");
                $(".button.verify-button").prop("disabled", true);
                $(".button.verify-button").addClass("disabled");
            } else if (!characters.test(this.userName)) {
                // console.log("Invalid email address", characters);
                $(".form-error:has(.email-error)").css("display","block");
                $("input#email-address").addClass("invalid-input");
                $(".button.verify-button").prop("disabled", true);
                $(".button.verify-button").addClass("disabled");
                this.userError = true;
            } else {
                $(".form-error:has(.email-error)").hide();
                this.checkIfEmailTaken(); // Commented out for Testing Purposes
                // console.log("|| === TESTING MODE EMAIL CHECK === ||");
                $("#email-address").removeClass("invalid-input");
                this.userError = false;
                // if (this.userNameMatchCheck == true) {
                //     $(".button.verify-button").prop("disabled", false);
                //     $(".button.verify-button").removeClass("disabled");
                // }
            }
        },
        checkIfEmailTaken() {
            let emailToCheck = this.userName;
            if (emailToCheck === "") {
                this.checkForVerifyLaunch();
                return;
            }

            let url =
                process.env.VUE_APP_APIURL +
                "/1.0/PAM/EmailTaken/?email=" +
                emailToCheck;
            var apiToken = this.registerApiToken;
            // console.log(apiToken);

            fetch(url, {
                method: "GET",
                headers: {
                "Content-Type": "application/json-patch+json",
                Authorization: "Bearer " + apiToken,
                },
            })
            .then((response) => response.json())
            .then((json) => {
                // console.log(json);

                if (json.data === true) {
                    this.userName = "";
                    alert("This email address is already in use.");
                }
                })
                .then(() => {
                    this.checkForVerifyLaunch();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        checkForVerifyLaunch() {
            if (this.userError == false) {
                if (this.userName === this.userNameMatch && this.userName !== "") {
                this.userNameMatchCheck = true;
                } else {
                this.userNameMatchCheck = false;
                }
            } else {
                $(".button.verify-button").prop("disabled", true);
                $(".button.verify-button").addClass("disabled");
            }
        },
        handlePersonaData(personaData, inqId, status, email) {
                
            this.step = 2;
            console.log(this.step);
            console.log('In handle');
            console.log(personaData);
            console.log("Troubleshooting Data");
            console.log(inqId);
            console.log(status);

            if (
                status === "completed" ||
                status === "approved" ||
                status === "passed"
            ) {
                //set the integral fields for BE first, in case issue with parameters from Persona
                this.summary = JSON.stringify(personaData);
                this.transactionID = inqId;
                this.verified = true;

                //prepopulate the fields

                this.userName = email;

                //check for then set first name
                if ("name-first" in personaData === true) {
                // console.log("First Name was returned.");
                this.firstName = personaData["name-first"].value;
                } else {
                console.log("First Name was not returned.");
                }

                //check for then set last name
                if ("name-last" in personaData === true) {
                // console.log("Last Name was returned");
                this.lastName = personaData["name-last"].value;
                } else {
                console.log("Last Name was not returned");
                }

                //process dob
                if ("birthdate" in personaData === true) {
                // console.log("Birthdate was returned");
                // this.date_birth = this.processDOB(personaData["birthdate"].value);
                this.date_birth = personaData["birthdate"].value;
                this.dateSelected();
                // console.log(this.date_birth);
                } else {
                console.log("Birthdate was not returned");
                }

                //process zip
                if ("address-postal-code" in personaData === true) {
                // console.log("Zip Code was returned");
                this.zipcode = this.processZip(
                    personaData["address-postal-code"].value,
                );
                } else {
                console.log("Zip Code not returned");
                }
                //process address street 1
                if ("address-street-1" in personaData === true) {
                // console.log("Address 1 Returned");
                this.mailingAddress = personaData["address-street-1"].value;
                } else {
                console.log("Address 1 Not Returned");
                }
                //process and check for address street 2
                if ("address-street-2" in personaData === true) {
                // console.log("Address 2 Returned");
                this.addressContinued = personaData["address-street-2"].value;
                } else {
                console.log("Address 2 Not Returned");
                }

                //is city returned
                if ("address-city" in personaData === true) {
                // console.log("City is returned");
                this.city = personaData["address-city"].value;
                } else {
                console.log("No City returned");
                }
                //is state returned
                if ("address-subdivision" in personaData === true) {
                // console.log("State is Returned");
                this.state = personaData["address-subdivision"].value;
                } else {
                console.log("No State Returned");
                }

                // this.country = personaData["address-country-code"].value;
                //need to handle this better for country code
                if (personaData["address-country-code"].value === "US") {
                this.country = "USA";
                }
            }

            if (status === "failed" || status === "declined") {
                this.step = 3;
            }
        },
        validate() {
            this.passwordLowercase = true;
            this.passwordUppercase = true;
            this.passwordNumber = true;
            this.passwordLength = true;
            this.passwordCharacter = true;
            this.passwordSpecial = true;
            
            if (this.password.length) {
                var password = this.password;
                var pswdLength = password.length;


                if (pswdLength < 10) {
                    this.passwordLength = false;
                }

                let pswdRegExA = /[A-Z]/g;
                let pswdRegExa = /[a-z]/g;
                let pswdRegExN = /\d/g;
                let pswdRegExS = /\s/;
                let pswdRegExSpecial = /[!@#$%^&*]/g;

                let pswdTestA = pswdRegExA.test(password);
                let pswdTesta = pswdRegExa.test(password);
                let pswdTestN = pswdRegExN.test(password);
                let pswdTestS = pswdRegExS.test(password);
                let pswdTestSpecial = pswdRegExSpecial.test(password);

                if (pswdTestA == false) {
                    this.passwordUppercase = false;
                }
                if (pswdTesta == false) {
                    this.passwordLowercase = false;
                }
                if (pswdTestN == false) {
                    this.passwordNumber = false;
                }
                if (pswdTestS == false) {
                    this.passwordCharacter = false;
                }
                if (pswdTestSpecial == false) {
                    this.passwordSpecial = false;
                }

                if (this.confirmPassword != '') {
                    this.match();
                }
            }
        },
        match() {
            if (this.password === this.confirmPassword) {
                this.passwordMatch = true;
            } else {
                this.passwordMatch = false;
            }

            this.handleError();
        },
        handleError() {
            if (
                this.passwordLowercase === false ||
                this.passwordUppercase === false ||
                this.passwordNumber === false ||
                this.passwordLength === false ||
                this.passwordCharacter === true ||
                this.passwordMatch === false ||
                this.passwordSpecial === false
            ) {
                this.passwordError = true;

            } else {
                this.passwordError = false;
            }

            this.validatePassword();
        },
        validateName(type) {
            let name;

            if (type === 'first') {
                name = this.firstName;
            } else {
                name = this.lastName;
            }

            let valid = false;

            let regex = /^[A-Za-z0-9,-.\s]+$/;

            let tested = regex.test(name);

            tested === true ? valid = true : valid = false;

            if (valid === false) {
                type === 'first' ? this.errorFirstName = true : this.errorLastName = true;
            } else {
                this.errorFirstName = false;
                this.errorLastName = false;
            }
        },
        validatePassword() {
            if (
                this.passwordError === false &&
                this.passwordMatch === true
            ) {
                this.passwordValid = true;
            } else {
                this.passwordValid = false;
            }

        },
        customFormatter(date) {
            return moment(date).format('MM/DD/yyyy');
        },
        getToken() {
            // then hit API with token
            this.getAPItoken()
                .then((token) => {
                    this.fetchData(token);
                });
        },
        async fetchData(token) {
            var apiToken = token;
            this.registerApiToken = apiToken;
            var urlProtocol = this.getProtocol();

            try {
                const response = await fetch(urlProtocol + process.env.VUE_APP_APIURL +
                    "/1.0/Games/StaticContentElements/StaticContentElement/GetContentElementByKey?contentKey=terms-conditions", {
                    headers: {
                        'Authorization': 'Bearer ' + apiToken,
                    },
                });
                const json = await response.json();

                var terms = json.data[0];
                this.termsTitle = terms.title;
                this.termsContent = terms.centralContent;
            } catch (error) {
                return this.errorMessage = error;
            }
        },
        dateSelected() {
            this.$nextTick(function () {
                function getAge(birth, target) {
                    let months = target.diff(birth, 'months', true)
                    let birthSpan = { year: Math.floor(months / 12), month: Math.floor(months) % 12, day: Math.round((months % 1) * target.daysInMonth(), 0) }
                    if (birthSpan.year < 1 && birthSpan.month < 1) {
                        return 10
                    } else if (birthSpan.year < 1) {
                        return 10
                    } else if (birthSpan.year < 2) {
                        return 10
                    } else {
                        return birthSpan.year
                    }

                }

                let birth = new Date(this.date_birth);
                let ageOfPerson = getAge(birth, moment());
                
                if (ageOfPerson < 18) {
                    this.birth_error = true
                    this.eighteen = false;
                } else {
                    this.birth_error = false;
                    this.eighteen = true;
                }
            });

        },
        submitCheck: function (e) {
            // e.preventDefault();
            let submission = 0;
            $(document).foundation();
            this.ageCheck === false ? this.ageCheckError = true : this.ageCheckError = false;
            this.agreeTermsCheck === false ? this.agreeTermsCheckError = true : this.agreeTermsCheckError = false;

            if (this.passwordValid === true && this.errorFirstName === false && this.errorLastName === false && this.emailError === false) {
                this.passwordError = false;
                let _this = this;

                const $form = $('#registerForm');
                new Foundation.Abide($form);
                $(document).on("formvalid.zf.abide", function () {
                    var apiToken = _this.registerApiToken;

                    let bodyRegister = {
                        "gender": _this.gender,
                        "userName": _this.userName,
                        "email": _this.userName,
                        "password": _this.password,
                        "firstName": _this.firstName,
                        "lastName": _this.lastName,
                        "address": {
                            "address": _this.mailingAddress,
                            "address2": _this.addressContinued,
                            "city": _this.city,
                            "state": _this.state,
                            "zipCode": _this.zipcode,
                            "plus4": _this.plus4,
                            "otpCode": _this.otpCode
                        },
                        "phoneNumber": _this.phoneNumber,
                        "birthdate": _this.date_birth,
                        "nickname": "",
                        "altPhone": "",
                        // "subscribeToOffers": _this.subscribeToOffers,
                        "termsAcceptance": _this.agreeTermsCheck,
                        "isUserOver18": _this.eighteen,
                        "transactionID": _this.transactionID,
                        "summary": _this.summary,
                        "verified": _this.verified,
                        "isMobile": _this.isMobile,
                        "appVersion": _this.appVersion,
                        "verifiedDate": new Date(),
                        "inquiryID": _this.inquiryID,
                        "notificationSettings": _this.notifications,
                        "primaryPhoneForTxt": true,
                        "registrationType": 0,
                        "altPhoneForTxt": true,
                        "phoneMFVerified": true,
                        "pendingMFPhoneVerification": true,
                        "isUserEnrolledInCashless": true,
                    }
                    bodyRegister.notificationSettings['subscribeToOffers'] = _this.subscribeToOffers;

                    const requestRegisterOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + apiToken
                        },
                        body: JSON.stringify(bodyRegister)
                    };

                    this.formEnable = false;
                    this.confirmSubmit = true;

                    if (submission === 0 && _this.checkSubmit === 0) {
                        _this.checkSubmit++;
                        fetch("https:" + process.env.VUE_APP_APIURL + "/1.0/PAM/RegisterUser", requestRegisterOptions)
                        .then(response => response.json())
                        .then(dataRegister => {
                            _this.checkSubmit = 0;
                            if (dataRegister.data === null) {
                                _this.registerErrorMsg = dataRegister.error.message;
                                let errorCode = dataRegister.error.errorCode;

                                setTimeout(() => {
                                    $('#errorRegisterModal').foundation('open');
                                }, 500);

                                _this.formEnable = true;
                                _this.confirmSubmit = false;

                                //Force Address is Invalid
                                if(errorCode === 5){
                                    let anchor = document.querySelector("#mailingAddressBlock");
                                    anchor.scrollIntoView({ behavior: "smooth", block: "start" });

                                    $('input[name="mailingAddress"], input[name="city"], input[name="state"], input[name="zipcode"]').addClass("is-invalid-input");
                                }

                            } else {
                                _this.redirectToUrl('/register/thanks-for-registering')
                                _this.formEnable = false;
                                _this.formSuccess = true;
                            }
                        });
                    }
                }).on("submit", function (ev) {
                    submission++;
                    ev.preventDefault();
                });
            } else {
                e.preventDefault();
                // this.registerErrorMsg = data.error.message;
                this.passwordError = true;

                // Check if the element is found
                setTimeout(() => {
                    const firstErrorElement = document.querySelector('.is-invalid-label');

                    if (firstErrorElement) {
                        // Scroll to the element
                        firstErrorElement.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                    }
                }, 100);
            }
        },
        setAppVersion(token) {
            let url = window.location.origin + "/registration/GetMinimumAppVersion";

            fetch(url, {
                method: "GET",
                headers: {
                "Content-Type": "application/json-patch+json",
                },
            })
                .then((response) => response.json())
                .then((json) => {
                // console.log('Registration Minimum App Version Data');
                this.minimumAppVersion = json.minAppVersionNumber;
                })
                .catch((error) => {
                return (this.errorMessage = error);
                });
            },
            kycTryAgain() {
            window.location.reload();
            },
            processError(err) {
            var newError;
            switch (err) {
                case "Invalid User":
                newError =
                    "There was a problem with registration. Please try again later.";
                break;
                default:
                newError = "There was an error. Please try again later.";
            }
            return newError;
            },
            processDOB(dob) {
            var newDOB = dob.replace(/-/g, "/");
            return newDOB;
            },
            processZip(zip) {
            var newZip,
                dashLocation = zip.indexOf("-");

            if (dashLocation !== -1) {
                newZip = zip.slice(0, dashLocation);
                // console.log(newZip);
            } else {
                newZip = zip;
            }

            return newZip;
            },
        formatPhone(val) {
            const numericValue = val.replace(/\D/g, '');
            if (numericValue.length === 10) {
                this.phoneNumber = `${numericValue.slice(0, 3)}-${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
            } else {
                this.phoneNumber = numericValue;
            }
        },
        nextStep: function () {
            this.step = this.step + 1;

            if (this.step === 1) {
                this.launchPersonaEmbed(this.userName, this.handlePersonaData);
            }
        },
        redirectToUrl(url) {
            window.location.href = url;
        }
    },
    computed: {
    },
};
</script>
<style>
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>